function normalizePath(input) {
  const raw = (input || '').toString();
  return raw.replace(/\\/g, '/').replace(/\s+/g, ' ').trim();
}

function coerceNumber(value) {
  if (typeof value === 'number') return value;
  if (typeof value === 'string') {
    const n = parseInt(value, 10);
    return Number.isFinite(n) ? n : undefined;
  }
  return undefined;
}

function coerceDate(obj) {
  if (!obj || typeof obj !== 'object') return undefined;
  const candidate = obj.created_at || obj.createdAt || obj.createdDate || obj.updated_at || obj.updatedAt || obj.lastUpdatedDate || obj.date;
  return candidate;
}

export function toCommonDiffLine(provider, rawLine) {
  const line = rawLine || {};
  const typeRaw = line.type || line.kind || '';
  let type = (typeRaw || '').toString().toLowerCase();
  if (type === 'add') type = 'added';
  if (type === 'remove') type = 'removed';
  const lineNumber = line.line_number !== undefined ? line.line_number : (line.lineNumber !== undefined ? line.lineNumber : line.ln || line.ln2 || line.newLine || line.oldLine);
  const line_number = coerceNumber(lineNumber) !== undefined ? coerceNumber(lineNumber) : (typeof line.line_number === 'string' ? line.line_number : line.line_number);
  const content = typeof line.content === 'string' ? line.content : (line.text || line.value || '');
  return { ...line, type, line_number, content };
}

export function toCommonComment(provider, rawComment) {
  const c = rawComment || {};
  const body = c.body || c.Body || c.content || c.Content || c.text || c.message || c.comment || c.description || '';
  const file = c.file || c.File || c.path || c.Path || '';
  const line = coerceNumber(c.line !== undefined ? c.line : (c.Line !== undefined ? c.Line : (c.position !== undefined ? c.position : undefined)));
  const thread_id = coerceNumber(c.thread_id !== undefined ? c.thread_id : (c.threadId !== undefined ? c.threadId : c.ThreadID));
  const created_at = coerceDate(c);
  return { ...c, body, file, line, thread_id, created_at };
}

export function toCommonFileEntry(provider, rawFile) {
  const f = rawFile || {};
  const pathRaw = f.path || f.filename || '';
  const path = normalizePath(pathRaw);
  const filename = f.filename || (path ? path.split('/').pop() : undefined);
  const diff_lines = Array.isArray(f.diff_lines) ? f.diff_lines.map((l) => toCommonDiffLine(provider, l)) : [];
  const comments = Array.isArray(f.comments) ? f.comments.map((c) => toCommonComment(provider, c)) : [];
  return { ...f, path, filename, diff_lines, comments };
}

export function toCommonFileResponse(provider, raw) {
  const src = raw || {};
  const diff_lines = Array.isArray(src.diff_lines) ? src.diff_lines.map((l) => toCommonDiffLine(provider, l)) : [];
  const comments = Array.isArray(src.comments) ? src.comments.map((c) => toCommonComment(provider, c)) : [];
  return { ...src, diff_lines, comments };
}

export function toCommonPRDetails(provider, raw) {
  const r = raw || {};
  const title = r.title || r.name || '';
  const status = r.status || r.state || '';
  const created_at = r.created_at || r.creationDate || coerceDate(r);
  const author = r.author || (r.createdBy && r.createdBy.displayName) || (r.user && (r.user.name || r.user.login)) || r.created_by || '';
  const files = Array.isArray(r.files) ? r.files.map((f) => toCommonFileEntry(provider, f)) : [];
  const comments = Array.isArray(r.comments) ? r.comments.map((c) => toCommonComment(provider, c)) : [];
  const total_comments = (typeof r.total_comments === 'number') ? r.total_comments : (comments.length);
  return { ...r, title, status, created_at, author, files, comments, total_comments };
}

const prAdapters = {
  toCommonPRDetails,
  toCommonFileEntry,
  toCommonFileResponse,
  toCommonComment,
  toCommonDiffLine,
};

export default prAdapters;




